export const renderJsonLd = (jsonLdObj) => {
  return `<script type="application/ld+json">${JSON.stringify(jsonLdObj, null, 2)}</script>`
}
